module.exports = __webpack_public_path__ + "img/Cherry in company A.0819cbc4.jpg";